import { Box, List, ListItem, Typography } from "@mui/joy";
import { QCSectionResult } from "../../types/qcTypes";
import {
  isPartiallyChecked,
  isUnchecked,
  partialSectionMessage,
} from "../../utils/qcPartialSections";

interface QCSectionErrorNoticeProps {
  sections: QCSectionResult[];
}

const QCSectionErrorNotice: React.FC<QCSectionErrorNoticeProps> = ({
  sections,
}) => {
  const unchecked = sections.filter(isUnchecked);
  const partial = sections.filter(isPartiallyChecked);
  return (
    <Box>
      {unchecked.length > 0 && (
        <>
          <Typography level="title-sm">
            Quality check could not fully process these sections:
          </Typography>
          <List marker="disc" size="sm" sx={{ pl: 2, my: 0.75 }}>
            {unchecked.map((section) => (
              <ListItem key={section.sectionIndex}>
                {section.sectionTitle}
              </ListItem>
            ))}
          </List>
        </>
      )}
      {partial.length > 0 && (
        <>
          <Typography level="title-sm">
            Some parts of these sections could not be checked:
          </Typography>
          <List marker="disc" size="sm" sx={{ pl: 2, my: 0.75 }}>
            {partial.map((section) => (
              <ListItem key={section.sectionIndex}>
                {section.sectionTitle}:{" "}
                {partialSectionMessage(section.partial!)}
              </ListItem>
            ))}
          </List>
        </>
      )}
    </Box>
  );
};

export default QCSectionErrorNotice;
